import PropTypes from 'prop-types'
import { HeaderTitle } from '../../../../common/HeaderTitle.jsx'
import { ListaElementyRejestru } from '../../lib/parts/ListaElementyRejestru.jsx'
import { useListaElementow } from '../../../../../api/domain/elementyRejstru/queries/useListaElementow.jsx'

const ViewListaElementyRejestru = (props) => {
    const titleName = 'Lista projektów'

    const listaPozycji = useListaElementow()

    return (
        <>
            <HeaderTitle
                breadcrumbLinks={[{ label: titleName }]}
                home
                nav
                destination={'/'}
                size={'fs-3'}
                title={titleName}
            />
            <ListaElementyRejestru
                exportFileName={`${
                    props.moje
                        ? 'moje_wszystkie_projekty'
                        : 'wszystkie_projekty'
                }`}
                listaPozycji={listaPozycji}
            />
        </>
    )
}

ViewListaElementyRejestru.propTypes = {
    moje: PropTypes.bool,
}

export default ViewListaElementyRejestru
